// extracted by mini-css-extract-plugin
module.exports = {"minMaxvalues":"PriceFilter_minMaxvalues__2wf8M"};